// extracted by mini-css-extract-plugin
module.exports = {"chooseClinicianText":"appointments__ChooseClinician__chooseClinicianText","chooseClinicianButton":"appointments__ChooseClinician__chooseClinicianButton"};